import { useLocation, useNavigate } from "react-router-dom";
import JUMonogram from "./JUMonogram";
import { CONTACTS, SCROLL } from "../data/content";

const QUICK = [
    { label: "Home", id: "top" },
    { label: "Packages", id: "packages" },
    { label: "Bespoke", to: "/bespoke" },
    { label: "Destinations", id: "destinations" },
    { label: "How It Works", id: "how-it-works" },
    { label: "Contact", id: "contact" },
];

export default function Footer() {
    const location = useLocation();
    const navigate = useNavigate();

    const go = (item) => {
        if (item.to) {
            if (location.pathname !== item.to) navigate(item.to);
            SCROLL.go("top");
        } else if (location.pathname !== "/") {
            navigate("/", { state: { scrollTo: item.id } });
        } else {
            SCROLL.go(item.id);
        }
    };

    return (
        <footer className="bg-navy text-cream">
            <div className="container-luxe py-16 grid gap-12 md:grid-cols-3">
                <div>
                    <JUMonogram size={56} />
                    <p className="mt-5 font-serif text-xl">
                        Journeys <span className="italic text-gold">Unscripted</span>
                    </p>
                    <p className="mt-2 text-sm text-cream/60 tracking-[0.14em] uppercase">
                        Travel Your Way · Experience Like a Local
                    </p>
                </div>

                <div>
                    <p className="eyebrow mb-5">Quick Links</p>
                    <ul className="space-y-2.5">
                        {QUICK.map((q) => (
                            <li key={q.label}>
                                <button
                                    data-testid={`footer-link-${q.label.toLowerCase().replace(/\s/g, "-")}`}
                                    onClick={() => go(q)}
                                    className="text-sm text-cream/75 hover:text-gold transition-colors duration-300"
                                >
                                    {q.label}
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>

                <div>
                    <p className="eyebrow mb-5">Speak With Us</p>
                    {CONTACTS.map((c) => (
                        <div key={c.name} className="mb-4">
                            <p className="text-sm text-cream/60">{c.fullName}</p>
                            <div className="flex items-center gap-4 mt-1">
                                <a
                                    data-testid={`footer-tel-${c.name.toLowerCase()}`}
                                    href={`tel:${c.tel}`}
                                    className="font-serif text-lg text-cream hover:text-gold transition-colors duration-300"
                                >
                                    {c.phoneDisplay}
                                </a>
                                <a
                                    data-testid={`footer-wa-${c.name.toLowerCase()}`}
                                    href={c.whatsapp}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-xs tracking-[0.14em] uppercase text-gold border-b border-gold/40 pb-0.5 hover:text-cream hover:border-cream/60 transition-colors duration-300"
                                >
                                    WhatsApp
                                </a>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <div className="border-t border-gold/15">
                <div className="container-luxe py-6 flex flex-col sm:flex-row justify-between gap-2 text-xs text-cream/45">
                    <span>© {new Date().getFullYear()} Journeys Unscripted. All rights reserved.</span>
                    <span className="font-serif italic">Private tours from India — never from a template.</span>
                </div>
            </div>
        </footer>
    );
}
